import { isMemedPrescription } from '../components/clinic/MemedPrescriptionBadge';
import { hasStoredMemedPdf } from '../services/memedService';

/** Mídia do certificado usada na assinatura, para exibir junto do selo. */
const SIGNATURE_MEDIA_LABEL: Record<string, string> = {
  icp_a1: 'Certificado A1',
  icp_a3: 'Certificado A3 (token/cartão)',
  icp_birdid: 'Certificado em nuvem BirdID',
  icp_vidaas: 'Certificado em nuvem VIDaaS',
};

export function signatureProviderLabel(provider?: string | null): string {
  return SIGNATURE_MEDIA_LABEL[String(provider || '')] || 'Certificado A1';
}

/** Receituário assinado com certificado ICP-Brasil (A1/A3), não Memed. */
export function isSignedPrescription(prescription: any): boolean {
  return Boolean(
    prescription?.is_signed
    && String(prescription?.signature_provider || '').startsWith('icp_')
    && !isMemedPrescription(prescription),
  );
}

/** Tem PDF guardado no Klinvia que pode ir por link: ICP-Brasil ou cópia da Memed. */
export function hasShareablePrescriptionPdf(prescription: any): boolean {
  return isSignedPrescription(prescription) || hasStoredMemedPdf(prescription);
}

export const PRESCRIPTIONS_SIGNED_EVENT = 'prescriptions:signed';

/** Avisa telas abertas (ex.: chips da evolução) que estas receitas mudaram de status. */
export function notifyPrescriptionsSigned(ids: string[]): void {
  if (!ids.length) return;
  window.dispatchEvent(new CustomEvent(PRESCRIPTIONS_SIGNED_EVENT, { detail: { ids } }));
}
